// export const BASE_URL = "http://localhost:5001/api";
export const BASE_URL = "https://api.goscanpay.com/api";
